export default __webpack_public_path__ + "static/media/la.c0d2ddfb.svg";